import * as pages from './page-names';

export const homeRoute = '/' + pages.homePageName;
export const administrationRoute = '/' + pages.administrationPageName;
export const userAdministrationRoute = administrationRoute + '/' + pages.userAdministrationPageName;
export const clientAdministrationRoute = administrationRoute + '/' + pages.clientAdministrationPageName;

export const exportConfigurationRoute = '/' + pages.exportConfigurationPageName;
export const configurationsExpConfRoute = exportConfigurationRoute + '/' + pages.configurationsPageName;
export const configurationTemplatesExpConfRoute = exportConfigurationRoute + '/' + pages.configurationTemplatesPageName;
export const fieldValueReplacementsRoute = exportConfigurationRoute + '/' + pages.fieldValueReplacementsPageName;
export const fieldAssignmentTemplatesExpConfRoute = exportConfigurationRoute + '/' + pages.fieldAssignmentTemplatesPageName;
export const emailTemplatesExpConfRoute = exportConfigurationRoute + '/' + pages.emailTemplatesPageName;
export const activationEmailTemplatesExpConfRoute = exportConfigurationRoute + '/' + pages.activationEmailTemplatesPageName;
export const historyExpConfRoute = exportConfigurationRoute + '/' + pages.historyPageName;

export const assetsRoute = '/' + pages.assetsPageName;
export const productAssetsRoute = assetsRoute + '/' + pages.productAssetsPageName;
export const brandLogosRoute = assetsRoute + '/' + pages.brandLogosPageName;
export const assetsStorageRoute = assetsRoute + '/' + pages.assetsStoragePageName;
export const assetsCollectionsRoute = assetsRoute + '/' + pages.assetCollectionsPageName;
export const assetsStorageSettingsRoute = assetsRoute + '/' + pages.assetsStorageSettingsPageName;

export const manualImportRoute = '/' + pages.manualImportPageName;
export const manualImportSalesOrdersRoute = manualImportRoute + '/' + pages.manualImportSalesOrdersPageName;
export const manualImportVendorDeliveryDateRoute = manualImportRoute + '/' + pages.manualImportVendorDeliveryDatePageName;
export const manualImportSerialNumbersRoute = manualImportRoute + '/' + pages.manualImportSerialNumbersPageName;

export const importConfigurationRoute = '/' + pages.importConfigurationsPageName;
export const importConfigurationConfigurationRoute = importConfigurationRoute + '/' + pages.importConfigurationsConfigurationPageName;
export const importConfigurationCreateRoute = importConfigurationConfigurationRoute + '/' + pages.importConfigurationCreatePageName;
export const importConfigurationProtocolRoute = importConfigurationRoute + '/' + pages.importConfigurationsProtocolPageName;
export const importConfigurationTemplateRoute = importConfigurationRoute + '/' + pages.configurationTemplatesPageName;
export const importConfigurationTemplateCreateRoute = importConfigurationTemplateRoute + '/' + pages.importConfigurationCreatePageName;
export const importConfigurationGlobalRoute = importConfigurationRoute + '/' + pages.importConfigurationsGlobalPageName;
export const importConfigurationGlobalCreateRoute = importConfigurationGlobalRoute + '/' + pages.importConfigurationCreatePageName;

export const settingsRoute = '/' + pages.settingsPageName;
export const emailSettingsRoute = settingsRoute + '/' + pages.emailSettingsPageName;

export const acodisWorkflowRoute = importConfigurationRoute + '/' + pages.acodisWorkflowsPageName;
export const acodisWorkflowCreateRoute = acodisWorkflowRoute + '/' + pages.acodisWorkflowCreatePageName;

export const vendorScoreCardRoute = '/' + pages.vendorScoreCardPageName;
export const vendorScoreCardSurveyRoute = vendorScoreCardRoute + '/' + pages.vendorScoreCardSurveyPageName;
export const vendorScoreCardAdministrationRoute = vendorScoreCardRoute + '/' + pages.vendorScoreCardAdministrationPageName;
export const vendorScoreCardVendorsRoute = vendorScoreCardRoute + '/' + pages.vendorScoreCardVendorsPageName;
export const vendorScoreCardVendorsDataRoute = vendorScoreCardRoute + '/' + pages.vendorScoreCardVendorsPageName + "/:id";

export const changePasswordRoute = '/' + pages.changePasswordPageName;
export const forgotPasswordRoute = '/' + pages.forgotPasswordPageName;
export const editProfileRoute = '/' + pages.editProfilePageName;
export const loginRoute = '/' + pages.loginPageName;
export const localLoginRoute = loginRoute + '/' + pages.localLoginPageName;
export const userEditRoute = '/' + pages.userEditPageName;
export const twoFactorAuthenticationRoute = '/' + pages.twoFactorAuthenticationPageName;
export const twoFactorAuthenticationRegistrationRoute = twoFactorAuthenticationRoute + '/' + pages.registrationPageName;
export const twoFactorAuthenticationRecoveryRoute = twoFactorAuthenticationRoute + '/' + pages.recoveryPageName;
